import BaseUISystem from '../BaseUISystem';
import BaseMenu from './BaseMenu';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import { UIActions } from '../../../State/UI/UIActions';
import { applyDefaultButtonAnimation } from '../UIHelper';
import Game from '../../../Game';
import { PopupID } from '../../../State/UI/PopupID';
import { StarterPackOfferLayout } from '../../../Layouts/StarterPackOfferLayout'
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { GameActions } from 'State/Game/GameActions';
import { ContextType } from 'State/Game/ContextType';
import { ProductId } from 'Utility/Product';
import { IAPHelper } from 'Utility/Helpers/IAP/IAPHelper';
import { formatStrikePrice, parseCurrency } from 'Utility/Currency';
import TextComponent from 'Component/Render/Text';

export default class SpecialOfferHandler extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.SPECIAL_OFFER_MENU, uiSystem, false);
    }

    public onCreate() {
        super.onCreate();

        this.layout = new StarterPackOfferLayout();
    }

    public onShow() {
        super.onShow();

        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        const { closeButton, buyButton } = this.layout;

        const productId = ProductId.STARTER_PACK_V3;
        const product = Game.sdk.getCatalog().products.find((e) => e.productId === productId);
        const iapReward = IAPHelper.CACHED_IAP_REWARDS_MAP()[productId];

        [closeButton, buyButton].forEach(o => applyDefaultButtonAnimation(o));
        this.addListener(closeButton, GameObjectEvent.SELECTED, () => UIActions.hidePopup(this.name), { once: true });
        this.addListener(buyButton, GameObjectEvent.SELECTED,
            () => GameActions.setContext(ContextType.PURCHASE_PRODUCT, { product: iapReward }));

        const { beforeValue, value, afterValue } = parseCurrency(product.price);

        const language = Game.sdk.getLanguage();
        const fullCostStr = value.toLocaleString(language, { maximumFractionDigits: 2, minimumFractionDigits: 2 });

        this.layout.priceText.getComponent(TextComponent).text = `${beforeValue}${fullCostStr}${afterValue}`;

        const strikePrice = formatStrikePrice({
            price: product.price,
            priceUsd: iapReward.usdPrice,
            strikePriceUsd: iapReward.usdPriceWithoutDiscount,
        });

        this.layout.oldPrice.getComponent(TextComponent).text = strikePrice;
    }

    private addListener(obj: GameObject, event: string, action: () => any, options?: {
        once?: boolean
    }) {
        if (options?.once) {
            obj.once(event, action);
        }
        else {
            obj.on(event, action);
        }
        this.cleanupManager.add(() => { obj.off(event, action) });
    }
}
